import PropTypes from "prop-types";
import styles from "./index.css";

const MAX_LINKS = 50;

const range = (start, end) =>
  Array(end - start + 1)
    .fill()
    .map((value, index) => start + index);

const Pagination = ({
  formatTranslation,
  shouldRender,
  currentPage,
  maxPage,
  url
}) => {
  if (!shouldRender) {
    return null;
  }

  const start = Math.max(1, currentPage - MAX_LINKS / 2);
  const end = Math.min(maxPage, currentPage + MAX_LINKS / 2);

  const adjustedStart = Math.max(1, end - MAX_LINKS);
  const adjustedEnd = Math.min(maxPage, start + MAX_LINKS);

  const pages = range(adjustedStart, adjustedEnd).filter(
    page => page !== currentPage
  );

  return (
    <div className={styles.paginationLinks}>
      {pages.map(page => (
        <a key={page} href={`${url}&page=${page}`}>
          {`${formatTranslation("plp_web_category_page")} ${page}`}
        </a>
      ))}
    </div>
  );
};

Pagination.propTypes = {
  formatTranslation: PropTypes.func.isRequired,
  shouldRender: PropTypes.bool.isRequired,
  currentPage: PropTypes.number.isRequired,
  maxPage: PropTypes.number.isRequired,
  url: PropTypes.string.isRequired
};

export default Pagination;
